module.exports = __webpack_public_path__ + "static/img/JDM.01c1381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/JDM.png
// module id = 9ITP
// module chunks = 46